import { render, staticRenderFns } from "./iconSvg.vue?vue&type=template&id=5bdac9b2&scoped=true"
import script from "./iconSvg.vue?vue&type=script&lang=js"
export * from "./iconSvg.vue?vue&type=script&lang=js"
import style0 from "./iconSvg.vue?vue&type=style&index=0&id=5bdac9b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdac9b2",
  null
  
)

export default component.exports